import React from "react";
import { isMobile } from "react-device-detect";
import { useTranslation } from "react-i18next";

export const LocationWrapper = ({ selectedRegion, handleSelectRegion }) => {
  const regions = [
    [
      "Indonesia",
      "https://d1puf2nnbcyl9q.cloudfront.net/sea-icon-360.png",
      "indonesia",
    ],
    [
      "Mongolia",
      "https://d1puf2nnbcyl9q.cloudfront.net/mongolia-icon-360.png",
      "mongolia",
    ],
    [
      "China",
      "https://d1puf2nnbcyl9q.cloudfront.net/china-icon-360.png",
      "china",
    ],
    [
      "Nepal",
      "https://d1puf2nnbcyl9q.cloudfront.net/nepal-icon-360.png",
      "nepal",
    ],
    [
      "Africa",
      "https://d1puf2nnbcyl9q.cloudfront.net/africa-icon-360.png",
      "africa",
    ],
    [
      "Japan",
      "https://d1puf2nnbcyl9q.cloudfront.net/japan-icon-360.png",
      "japan",
    ],
  ];

  const { t } = useTranslation();

  return (
    <div className="LocationContainer">
      {isMobile ? (
        <p style={{ fontWeight: "800", fontSize: "20px" }}>
          {t("where_to", {
            defaultValue: "Where to?",
          })}
        </p>
      ) : (
        <p style={{ fontWeight: "800" }}>{t("filter_by_destination")}</p>
      )}

      <div className="LocationGridBox">
        {regions.map(([region, image, translationKey], key) => (
          <div className="LocationBoxWrapper">
            <button
              className={`LocationBox ${
                selectedRegion === region.toLowerCase() ? "selected" : ""
              }`}
              onClick={() => handleSelectRegion(region.toLowerCase())}
              style={{
                backgroundImage: `url('${image}')`,
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
            ></button>
            <p style={{ marginTop: "3px" }}>
              {t(`destinations.${translationKey}`)}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};
